<template>
  <div class="page-content">
    <!-- <HeaderHomePage @openModal="showLogin" />
    <main class="page_main">
      <div class="mask"></div>
      <section class="section section_hero" id="main">
        <DotsList />
        <div class="container">
          <div class="hero-block">
            <div class="hero-block__description hero-block-description">
              <div data-scroll-animation="y, autoAlpha" data-stagger>
                <h1 data-load-item>
                  Boost Your Sales and Improve Customer Experience with a Custom
                  ChatGPT Chatbot on your website
                </h1>
                <div class="hero-block-description__text">
                  <span
                    class="hero-block-description__text--advances pt-3"
                    data-load-item
                  >
                    Increase your conversions by 67% and reduce support costs by
                    30%
                  </span>
                  <span
                    class="hero-block-description__text--build pt-3"
                    data-load-item
                  >
                    Create your own ChatGPT ChatBot for your website in just 5
                    minutes
                  </span>
                </div>
              </div>
            </div>
            <div class="hero-block__image">
              <div
                class="ps-xxl-5 mb-4 pb-3 mb-lg-0 pb-lg-0"
                data-scroll-animation="y, autoAlpha"
              >
                <img
                  class="img-fluid w-100"
                  src="./../assets/img/chats-hero-min.png"
                  alt="chats hero"
                  data-load-item
                />
              </div>
            </div>
          </div>
          <div
            class="d-flex justify-content-center pt-5 mt-3 mt-md-5"
            data-load-item
          >
            <a
              class="btn btn-primary w-100 w-sm-auto"
              data-cta="2"
              @click="showLogin"
              >Log In</a
            >
          </div>
        </div>
      </section>
      <section
        class="section section_reasons"
        id="reasons"
        data-scroll-trigger="true"
      >
        <DotsList />
        <div class="container">
          <div data-scroll-trigger="true">
            <h2 class="text-center" data-scroll-animation="y, autoAlpha">
              <strong>Benefits for your business</strong>
            </h2>
          </div>
          <div class="row g-0">
            <div class="col-12 col-xxl-10 mx-auto">
              <ol class="reasons_list">
                <li class="reasons_list__item" data-scroll-trigger="true">
                  <div class="row reason align-items-center">
                    <div class="col-12 col-md-6">
                      <div
                        class="reason_image"
                        data-scroll-animation="y, autoAlpha"
                      >
                        <img
                          class="img-fluid"
                          src="./../assets/img/reasons/r-1.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6"
                      data-scroll-animation="y, autoAlpha"
                      data-stagger
                    >
                      <h3 class="reason_title">
                        Boost engagement with an AI chatbot
                      </h3>
                      <ul class="reason_list">
                        <li>
                          Engage with visitors and never miss a chance to
                          interact with your potential clients.
                        </li>
                        <li>
                          Get leads through conversations and qualify your
                          prospects automatically.
                        </li>
                        <li>Turn boring web forms into conversations</li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li class="reasons_list__item" data-scroll-trigger="true">
                  <div
                    class="row flex-md-row-reverse reason align-items-center"
                  >
                    <div class="col-12 col-md-6">
                      <div
                        class="reason_image"
                        data-scroll-animation="y, autoAlpha"
                      >
                        <img
                          class="img-fluid"
                          src="./../assets/img/reasons/r-2.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6"
                      data-scroll-animation="y, autoAlpha"
                      data-stagger
                    >
                      <h3 class="reason_title">
                        Get more leads and increase sales
                      </h3>
                      <ul class="reason_list">
                        <li>
                          Boost sales by providing quick and personalized
                          product recommendations
                        </li>
                        <li>
                          Gather customer information through personalized
                          conversations.
                        </li>
                        <li>
                          Sell more products using chatbots and grow your
                          revenue effortlessly.
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li class="reasons_list__item" data-scroll-trigger="true">
                  <div class="row reason align-items-center">
                    <div class="col-12 col-md-6">
                      <div
                        class="reason_image mb-0"
                        data-scroll-animation="y, autoAlpha"
                      >
                        <img
                          class="img-fluid"
                          src="./../assets/img/reasons/r-3.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      class="col-12 col-md-6"
                      data-scroll-animation="y, autoAlpha"
                      data-stagger
                    >
                      <h3 class="reason_title">Optimize your Support</h3>
                      <ul class="reason_list">
                        <li>
                          Improve customer satisfaction by answering queries in
                          real-time
                        </li>
                        <li>Reduce support queues and increase efficiency</li>
                        <li>
                          Provide instant and relevant answers, even outside of
                          working hours.
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section
        class="section section_get_consultation section--bg-dark"
        id="get-consultation"
      >
        <DotsList />
        <div class="container" data-scroll-trigger="true">
          <div class="center" data-scroll-animation="y, autoAlpha" data-stagger>
            <img class="send-icon" src="./../assets/img/send.png" alt="" />
            <h2 class="pb-3 pt-4">
              Build ChatGPT widget for your website<br />
              without developers in just 10 minutes!
            </h2>
            <div class="row g-0">
              <div
                class="col-12 col-sm-10 col-md-8 col-lg-12 col-xl-10 mx-auto"
              >
                <ConsultationForm />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section section_result" id="how-it-works">
        <DotsList />
        <div class="container" data-scroll-trigger="true">
          <div class="row" data-scroll-animation="y, autoAlpha" data-stagger>
            <div class="mt-4 col-12">
              <h2 class="text-center">
                <strong>HOW IT WORKS</strong>
              </h2>
            </div>
            <div class="col-12 col-lg-8 col-xl-7 mx-auto mt-3">
              <p class="lg text-center">
                Integrating ChatGPT AI widget to your website is a breeze.
                Simply <br />
                sign up, have AI & ML build a model using your data and
                copy-paste our code onto your website and enjoy the benefits of
                a fully <br />
                functional ChatGPT AI widget.
              </p>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="advantages_wrapper">
            <div class="mt-5" data-scroll-trigger="true">
              <h4 class="text-center" data-scroll-animation="y, autoAlpha">
                10 minutes<br />
                to integrate
              </h4>
            </div>
            <svg
              viewBox="0 0 370 521"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="advantages-line-path"
              preserveAspectRatio="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M282.447 0.595276C285.83 0.501669 289.337 0.471763 292.913 0.529308L292.897 1.52918C289.336 1.47189 285.845 1.50165 282.475 1.59489L282.447 0.595276ZM303.376 0.958879C306.845 1.19338 310.332 1.52681 313.793 1.97943L313.663 2.97099C310.225 2.52135 306.759 2.18985 303.309 1.9566L303.376 0.958879ZM261.564 1.97593C264.702 1.65219 268.214 1.34198 272 1.09023L272.066 2.08803C268.294 2.33889 264.794 2.64802 261.666 2.97065L261.564 1.97593ZM247.409 3.81769C248.277 3.67629 249.55 3.47719 251.171 3.24595L251.312 4.23593C249.698 4.46617 248.432 4.66427 247.57 4.80469C247.139 4.87489 246.809 4.93068 246.587 4.96886C246.476 4.98795 246.392 5.00263 246.336 5.01252L246.273 5.02369L246.254 5.02716L246.252 5.02736L246.075 4.04325L246.076 4.04299L246.097 4.03925L246.162 4.02771C246.22 4.01759 246.305 4.00266 246.417 3.98333C246.642 3.94467 246.975 3.88839 247.409 3.81769ZM324.125 3.73079C327.593 4.46646 330.987 5.3509 334.256 6.40667L333.949 7.35829C330.716 6.31441 327.356 5.43848 323.918 4.70902L324.125 3.73079ZM344.007 10.2846C347.238 11.8533 350.262 13.6554 353.015 15.7207L352.415 16.5206C349.72 14.4985 346.751 12.7288 343.57 11.1841L344.007 10.2846ZM360.612 23.0095C362.78 25.7127 364.59 28.7216 365.973 32.0662L365.049 32.4482C363.703 29.1941 361.943 26.2668 359.832 23.6352L360.612 23.0095ZM368.655 42.2256C369.093 45.5033 369.197 49.0222 368.934 52.7985L367.936 52.7289C368.195 49.0141 368.092 45.563 367.664 42.3578L368.655 42.2256ZM367.419 63.0943C367.052 64.78 366.621 66.509 366.124 68.2823C365.658 69.9455 365.08 71.5444 364.395 73.0811L363.482 72.6739C364.147 71.1821 364.708 69.6292 365.161 68.0125C365.653 66.2572 366.079 64.5471 366.442 62.8812L367.419 63.0943ZM359.022 81.5825C356.906 84.0807 354.427 86.3605 351.618 88.4408L351.023 87.6372C353.777 85.5974 356.198 83.3692 358.259 80.9362L359.022 81.5825ZM343.033 93.7011C340.173 95.1597 337.099 96.4893 333.83 97.7011L333.483 96.7635C336.72 95.5634 339.758 94.249 342.578 92.8103L343.033 93.7011ZM324.331 100.754C321.231 101.617 317.999 102.4 314.647 103.111L314.44 102.133C317.773 101.425 320.985 100.647 324.063 99.7909L324.331 100.754ZM304.828 104.94C301.606 105.465 298.294 105.935 294.901 106.358L294.777 105.365C298.159 104.945 301.458 104.475 304.668 103.953L304.828 104.94ZM284.9 107.446C281.662 107.751 278.363 108.019 275.01 108.254L274.94 107.257C278.286 107.022 281.577 106.754 284.806 106.45L284.9 107.446ZM265.033 108.854C261.728 109.021 258.379 109.162 254.992 109.279L254.958 108.279C258.34 108.162 261.683 108.022 264.982 107.855L265.033 108.854ZM145.206 109.019C141.855 109.001 138.522 108.992 135.212 108.994L135.211 107.994C138.523 107.992 141.858 108.001 145.211 108.019L145.206 109.019ZM125.28 109.041C121.907 109.071 118.563 109.116 115.255 109.18L115.236 108.18C118.548 108.116 121.895 108.071 125.271 108.041L125.28 109.041ZM165.163 109.209C161.828 109.167 158.502 109.128 155.189 109.096L155.199 108.096C158.513 108.128 161.84 108.167 165.176 108.209L165.163 109.209ZM178.546 109.389C177.415 109.373 176.285 109.357 175.155 109.342L175.169 108.342C176.307 108.358 177.446 108.373 178.584 108.389C180.771 108.42 182.958 108.45 185.145 108.48L185.132 109.48C182.936 109.45 180.74 109.419 178.546 109.389ZM105.281 109.436C101.932 109.545 98.6279 109.676 95.3731 109.835L95.3245 108.836C98.5852 108.677 101.895 108.545 105.248 108.437L105.281 109.436ZM245.063 109.555C241.758 109.626 238.424 109.679 235.065 109.716L235.054 108.717C238.41 108.679 241.741 108.627 245.041 108.555L245.063 109.555ZM205.095 109.712C201.777 109.683 198.451 109.648 195.119 109.608L195.131 108.608C198.462 108.648 201.787 108.683 205.103 108.712L205.095 109.712ZM225.063 109.783C221.758 109.792 218.434 109.789 215.096 109.776L215.1 108.776C218.436 108.789 221.758 108.792 225.06 108.783L225.063 109.783ZM85.3526 110.421C81.9697 110.655 78.6516 110.923 75.4056 111.231L75.3113 110.236C78.5665 109.927 81.8932 109.658 85.2837 109.423L85.3526 110.421ZM65.5501 112.318C62.1712 112.747 58.8879 113.229 55.7098 113.767L55.5427 112.781C58.7358 112.24 62.0328 111.757 65.424 111.326L65.5501 112.318ZM45.8943 115.696C42.5268 116.459 39.3114 117.305 36.2622 118.24L35.9688 117.284C39.0448 116.341 42.2846 115.489 45.6732 114.721L45.8943 115.696ZM26.9303 121.62C23.7353 122.984 20.8023 124.489 18.1544 126.148L17.6236 125.3C20.3219 123.61 23.3021 122.082 26.5375 120.7L26.9303 121.62ZM10.4614 132.215C8.09964 134.603 6.17431 137.227 4.72218 140.11L3.82907 139.66C5.33213 136.676 7.32134 133.968 9.75051 131.512L10.4614 132.215ZM1.84565 149.387C1.61679 150.993 1.5 152.663 1.5 154.401C1.5 156.132 1.60686 157.793 1.81536 159.387L0.823802 159.517C0.609407 157.878 0.500004 156.173 0.5 154.401C0.499996 152.618 0.619811 150.901 0.855656 149.246L1.84565 149.387ZM4.50989 168.76C5.90425 171.732 7.75956 174.413 10.0258 176.837L9.29523 177.52C6.9628 175.025 5.04645 172.258 3.60457 169.185L4.50989 168.76ZM17.5801 183.097C20.2209 184.825 23.1423 186.38 26.3098 187.782L25.9049 188.697C22.6961 187.276 19.7257 185.696 17.0325 183.934L17.5801 183.097ZM35.623 191.277C38.6667 192.246 41.8619 193.119 45.1869 193.912L44.955 194.885C41.6097 194.087 38.3902 193.207 35.3196 192.23L35.623 191.277ZM54.9306 195.951C58.1288 196.538 61.4144 197.07 64.7712 197.557L64.6277 198.546C61.2604 198.058 57.9623 197.524 54.75 196.935L54.9306 195.951ZM74.6657 198.849C77.9303 199.233 81.2433 199.587 84.5912 199.918L84.4927 200.914C81.1398 200.582 77.8206 200.227 74.5487 199.842L74.6657 198.849ZM94.5353 200.838C97.8376 201.125 101.16 201.4 104.49 201.669L104.41 202.666C101.078 202.396 97.7538 202.122 94.4486 201.834L94.5353 200.838ZM114.451 202.466C117.78 202.732 121.105 203.002 124.412 203.282L124.328 204.278C121.023 203.998 117.7 203.729 114.371 203.463L114.451 202.466ZM134.37 204.17C137.722 204.488 141.043 204.826 144.319 205.192L144.208 206.186C140.938 205.821 137.623 205.484 134.276 205.166L134.37 204.17ZM154.248 206.417C157.616 206.876 160.919 207.378 164.14 207.931L163.97 208.917C160.762 208.365 157.471 207.866 154.113 207.407L154.248 206.417ZM173.961 209.851C177.316 210.596 180.551 211.419 183.644 212.332L183.361 213.291C180.293 212.385 177.08 211.568 173.744 210.827L173.961 209.851ZM193.13 215.624C196.383 216.951 199.408 218.426 202.17 220.074L201.658 220.933C198.946 219.315 195.966 217.861 192.752 216.55L193.13 215.624ZM210.199 226.097C212.689 228.481 214.768 231.133 216.375 234.089L215.496 234.566C213.943 231.709 211.93 229.138 209.507 226.819L210.199 226.097ZM219.667 243.603C219.954 245.232 220.131 246.929 220.193 248.697C220.257 250.511 220.205 252.255 220.043 253.93L219.048 253.834C219.205 252.204 219.256 250.505 219.194 248.732C219.134 247.008 218.961 245.357 218.682 243.776L219.667 243.603ZM217.484 263.903C216.076 267.086 214.154 269.938 211.786 272.5L211.052 271.822C213.35 269.334 215.209 266.573 216.569 263.499L217.484 263.903ZM203.869 279.068C201.116 280.856 198.072 282.453 194.783 283.889L194.383 282.972C197.631 281.555 200.625 279.982 203.325 278.229L203.869 279.068ZM185.176 287.442C182.016 288.435 178.704 289.329 175.267 290.141L175.036 289.168C178.454 288.36 181.743 287.472 184.877 286.488L185.176 287.442ZM165.232 292.237C161.949 292.843 158.584 293.396 155.156 293.909L155.009 292.92C158.427 292.408 161.78 291.857 165.05 291.253L165.232 292.237ZM145.031 295.297C141.682 295.719 138.293 296.116 134.881 296.497L134.769 295.504C138.179 295.123 141.563 294.726 144.906 294.304L145.031 295.297ZM119.638 298.122C117.944 298.298 116.249 298.474 114.557 298.652L114.453 297.657C116.146 297.48 117.84 297.304 119.534 297.127C121.229 296.951 122.923 296.775 124.615 296.597L124.719 297.592C123.027 297.77 121.332 297.946 119.638 298.122ZM104.403 299.746C100.994 300.127 97.6096 300.523 94.2664 300.945L94.1412 299.953C97.4903 299.53 100.879 299.133 104.292 298.752L104.403 299.746ZM84.1638 302.33C80.7458 302.841 77.3923 303.392 74.1224 303.996L73.9408 303.013C77.2237 302.407 80.5885 301.853 84.0159 301.341L84.1638 302.33ZM64.1358 306.081C60.7181 306.889 57.4295 307.777 54.2958 308.761L53.9961 307.807C57.1563 306.815 60.4685 305.921 63.9058 305.108L64.1358 306.081ZM44.7893 312.277C41.5414 313.694 38.5474 315.267 35.8474 317.02L35.3028 316.181C38.0564 314.393 41.1002 312.796 44.3894 311.361L44.7893 312.277ZM28.1207 323.428C25.822 325.916 23.9633 328.676 22.6031 331.751L21.6886 331.346C23.0965 328.164 25.0185 325.312 27.3862 322.749L28.1207 323.428ZM20.1246 341.415C19.9671 343.045 19.9165 344.744 19.9784 346.518C20.0394 348.261 20.2051 349.932 20.4701 351.533L19.4836 351.696C19.2111 350.051 19.0414 348.337 18.9791 346.553C18.9156 344.738 18.9673 342.995 19.1293 341.319L20.1246 341.415ZM23.5018 360.928C25.0004 363.892 26.9468 366.555 29.2889 368.954L28.5733 369.653C26.1653 367.186 24.1573 364.44 22.6094 361.379L23.5018 360.928ZM37.0411 375.144C39.7473 376.856 42.7255 378.388 45.9389 379.766L45.5448 380.685C42.2909 379.29 39.2644 377.734 36.5065 375.989L37.0411 375.144ZM55.3397 383.184C58.4436 384.142 61.6934 385.003 65.065 385.782L64.84 386.756C61.4486 385.973 58.1751 385.106 55.0448 384.14L55.3397 383.184ZM74.9541 387.79C78.1954 388.369 81.5164 388.894 84.8991 389.377L84.7578 390.367C81.3656 389.882 78.0328 389.356 74.7783 388.774L74.9541 387.79ZM94.8887 390.674C98.1963 391.067 101.543 391.432 104.913 391.782L104.81 392.776C101.436 392.427 98.0845 392.06 94.7708 391.667L94.8887 390.674ZM120.487 393.309C121.994 393.452 123.501 393.596 125.008 393.74L124.912 394.736C123.407 394.591 121.899 394.448 120.39 394.304C118.546 394.128 116.702 393.953 114.86 393.775L114.956 392.78C116.799 392.957 118.643 393.133 120.487 393.309ZM135.06 394.733C138.436 395.079 141.789 395.441 145.103 395.829L144.987 396.822C141.679 396.435 138.331 396.074 134.958 395.727L135.06 394.733ZM155.123 397.11C158.515 397.586 161.846 398.104 165.096 398.675L164.923 399.66C161.686 399.091 158.367 398.575 154.984 398.1L155.123 397.11ZM175.027 400.66C178.43 401.435 181.71 402.292 184.844 403.25L184.551 404.206C181.445 403.257 178.188 402.406 174.805 401.635L175.027 400.66ZM194.365 406.689C197.622 408.082 200.642 409.637 203.384 411.385L202.847 412.228C200.158 410.514 197.187 408.983 193.972 407.609L194.365 406.689ZM211.275 417.794C213.645 420.292 215.594 423.076 217.06 426.188L216.155 426.614C214.738 423.606 212.851 420.908 210.549 418.482L211.275 417.794ZM219.87 435.97C220.084 437.621 220.194 439.341 220.194 441.131C220.194 442.795 220.098 444.425 219.91 446.022L218.917 445.905C219.1 444.348 219.194 442.757 219.194 441.131C219.194 439.381 219.087 437.705 218.878 436.099L219.87 435.97ZM217.632 455.432C216.503 458.448 215.02 461.321 213.222 464.059L212.386 463.51C214.146 460.83 215.594 458.023 216.695 455.082L217.632 455.432ZM207.148 471.633C204.984 473.895 202.589 476.05 199.991 478.102L199.371 477.318C201.937 475.29 204.297 473.167 206.425 470.942L207.148 471.633ZM192.1 483.656C189.442 485.332 186.642 486.93 183.719 488.453L183.257 487.567C186.158 486.054 188.934 484.47 191.566 482.81L192.1 483.656ZM175.014 492.625C172.121 493.902 169.141 495.119 166.087 496.279L165.732 495.344C168.77 494.19 171.735 492.979 174.61 491.71L175.014 492.625ZM157.004 499.499C153.986 500.499 150.915 501.449 147.806 502.353L147.527 501.393C150.625 500.492 153.684 499.545 156.69 498.55L157.004 499.499ZM138.522 504.893C135.425 505.689 132.303 506.443 129.169 507.158L128.947 506.183C132.073 505.47 135.185 504.718 138.273 503.924L138.522 504.893ZM119.764 509.182C116.61 509.822 113.457 510.424 110.316 510.991L110.139 510.006C113.273 509.441 116.419 508.84 119.565 508.202L119.764 509.182ZM100.833 512.605C97.6296 513.118 94.4534 513.596 91.3177 514.042L91.1771 513.052C94.3072 512.607 97.4775 512.13 100.674 511.617L100.833 512.605ZM81.7739 515.316C78.5156 515.723 75.32 516.096 72.2042 516.437L72.0955 515.443C75.2064 515.103 78.3968 514.73 81.6497 514.323L81.7739 515.316ZM62.6165 517.413C59.2886 517.727 56.0867 518.004 53.0358 518.248L52.9561 517.252C56.0025 517.008 59.1996 516.731 62.5225 516.418L62.6165 517.413ZM43.4774 518.945C39.934 519.178 36.7012 519.362 33.836 519.507L33.7854 518.508C36.6459 518.363 39.8737 518.18 43.4118 517.947L43.4774 518.945ZM19.4856 520.035L19.4788 519.535L19.473 519.035L19.4912 519.035L19.5497 519.034C19.6018 519.033 19.6797 519.032 19.7829 519.03C19.9894 519.026 20.2969 519.02 20.7008 519.011C21.5084 518.992 22.7011 518.961 24.2398 518.911L24.2726 519.91C22.7304 519.961 21.5344 519.992 20.7235 520.011C20.3181 520.02 20.009 520.026 19.801 520.03C19.6971 520.032 19.6184 520.033 19.5656 520.034L19.487 520.035H19.4856Z"
                fill="black"
                fill-opacity="0.15"
              />
            </svg>
            <div data-scroll-trigger="true">
              <ul
                class="advantages_list p-0 list-unstyled"
                data-scroll-animation="y, autoAlpha"
                data-stagger
              >
                <li class="advantages_list__item">
                  <div
                    class="d-flex flex-column flex-md-row-reverse align-items-center advantage"
                  >
                    <div class="advantage_icon ms-md-3 ms-xxl-4">
                      <img src="./../assets/img/icons/game.svg" alt="" />
                    </div>

                    <p class="advantage_text m-0">Log In</p>
                  </div>
                </li>
                <li class="advantages_list__item ms-md-auto right">
                  <div
                    class="d-flex flex-column flex-md-row align-items-center advantage"
                  >
                    <div class="advantage_icon me-md-3 me-xxl-4">
                      <img src="./../assets/img/icons/wallet.svg" alt="" />
                    </div>
                    <p class="advantage_text m-0 text-md-end">
                      Input your website URL
                    </p>
                  </div>
                </li>
                <li class="advantages_list__item">
                  <div
                    class="d-flex flex-column flex-md-row-reverse align-items-center advantage"
                  >
                    <div class="advantage_icon ms-md-3 ms-xxl-4">
                      <img src="./../assets/img/icons/calendar.svg" alt="" />
                    </div>
                    <p class="advantage_text m-0 text-md-end">
                      Have AI & ML build a model using data from your website
                    </p>
                  </div>
                </li>
                <li class="advantages_list__item ms-md-auto right">
                  <div
                    class="d-flex flex-column flex-md-row align-items-center advantage"
                  >
                    <div class="advantage_icon me-md-3 me-xxl-4">
                      <img src="./../assets/img/icons/phone.svg" alt="" />
                    </div>

                    <p class="advantage_text m-0">
                      Integrated code into your website in few clicks
                    </p>
                  </div>
                </li>
                <li class="advantages_list__item">
                  <div
                    class="d-flex flex-column flex-md-row-reverse align-items-center advantage"
                  >
                    <div class="advantage_icon ms-md-3 ms-xxl-4">
                      <img src="./../assets/img/icons/discount.svg" alt="" />
                    </div>
                    <p class="advantage_text m-0 text-md-end">
                      Get the power of ChatGPT widget on your website
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="ai-solution" class="section section_result__details">
        <DotsList />
        <div class="container">
          <div data-scroll-trigger="true">
            <h2 class="text-center" data-scroll-animation="y, autoAlpha">
              Transform Your Business with Our AI Solutions
            </h2>
          </div>
          <ul class="result_details__list list-unstyled mt-lg-5 mr-0">
            <li
              class="result_details__list_item py-5"
              data-scroll-trigger="true"
            >
              <div
                class="row align-items-md-center justify-content-center justify-content-start"
              >
                <div class="col-12 col-sm-8 mx-auto mx-md-0 col-lg-6">
                  <div
                    class="pe-lg-3 pe-xxl-5 mb-4 pb-3 mb-lg-0 pb-lg-0 mx-auto"
                    data-scroll-animation="y, autoAlpha"
                  >
                    <img
                      class="img-fluid w-100"
                      src="./../assets/img/details/details-1-mod-min.png"
                      alt="details-1"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-10 col-lg-6 mx-auto mx-lg-0">
                  <div
                    class="pe-xxl-4 text-center text-lg-start"
                    data-scroll-animation="y, autoAlpha"
                    data-stagger
                  >
                    <h3 class="pe-xxl-4">Website Chatbots</h3>
                    <p>
                      Revolutionize your customer service with our AI-powered
                      chatbots. Our chatbots can provide 24/7 support, reduce
                      customer response times, and increase customer
                      satisfaction.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="result_details__list_item py-5"
              data-scroll-trigger="true"
            >
              <div class="row align-items-md-center flex-lg-row-reverse">
                <div
                  class="col-12 col-sm-8 mx-auto mx-lg-0 col-lg-6 col-xxl-7 ms-xxl-auto"
                >
                  <div
                    class="ps-xxl-5 mb-4 pb-3 mb-lg-0 pb-lg-0"
                    data-scroll-animation="y, autoAlpha"
                  >
                    <img
                      class="img-fluid w-100"
                      src="./../assets/img/details/details-2-mod-min.png"
                      alt="details-2"
                    />
                  </div>
                </div>
                <div
                  class="col-12 col-sm-10 col-lg-6 col-xxl-5 mx-auto mx-lg-0"
                >
                  <div
                    class="text-center text-lg-start"
                    data-scroll-animation="y, autoAlpha"
                    data-stagger
                  >
                    <h3 class="">Website AI Search</h3>
                    <p>
                      Make it easy for customers to find what they're looking
                      for with our AI-powered search technology. Chatbot AI
                      crawls your website automatically and gives you a simple
                      embed code for AI Search.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="result_details__list_item py-5"
              data-scroll-trigger="true"
            >
              <div class="row align-items-md-center justify-content-center">
                <div class="col-12 col-sm-8 mx-auto mx-lg-0 col-lg-6">
                  <div
                    class="mb-4 pb-3 mb-lg-0 pb-lg-0"
                    data-scroll-animation="y, autoAlpha"
                  >
                    <img
                      class="img-fluid w-100"
                      src="./../assets/img/details/details-3-mod-min.png"
                      alt="details-3"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-8 col-lg-6">
                  <div
                    class="text-center text-lg-start"
                    data-scroll-animation="y, autoAlpha"
                    data-stagger
                  >
                    <h3 class="">AI Expert Systems</h3>
                    <p>
                      AI & ML analyzes and learns from data in a variety of
                      formats, including PDF, XML, and CSV documents, to
                      simplify data analysis and improve decision-making.
                      Improve overall business performance with our expert
                      system.
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div
            class="d-flex justify-content-center mt-5"
            data-scroll-trigger="true"
          >
            <a
              class="btn btn-primary w-100 w-sm-auto"
              data-scroll-animation="y, autoAlpha"
              @click="showLogin"
              >Log In</a
            >
          </div>
        </div>
      </section>
      <div class="section--bg-dark mt-5 pt-0" id="about-wrapper">
        <section class="section section_contact" id="contact">
          <DotsList />
          <picture class="contact_image">
            <source
              srcset="./../assets/img/contact.png"
              media="(min-width: 991px)"
            />
            <img src="./../assets/img/placeholder.jpg" alt="" />
          </picture>
          <div class="container">
            <div class="center">
              <div data-scroll-trigger="true">
                <div
                  data-scroll-animation="y, autoAlpha"
                  data-stagger
                  class="center"
                >
                  <img
                    class="send-icon"
                    src="./../assets/img/send.png"
                    alt=""
                  />
                  <h2 class="pb-3 pt-4">Do you have any questions?</h2>
                  <div class="row g-0">
                    <div class="col-12 col-lg-8 col-xxl-6 mx-auto">
                      <p>Leave a request and we will contact you shortly.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row g-0 pb-4">
                <div
                  class="col-12 col-sm-10 col-md-8 col-lg-6 col-xxl-4 mx-auto"
                >
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>  -->
 <!-- <FooterHomePage @openModal="showLogin" /> -->
    <Modal :showModal="showLoginModal" @cancel="cancelLogin">
      <LoginForm
        @switchMode="switchToRegistrationMode"
        @forgetPassword="forgetPassword"
      />
    </Modal>
    <Modal :showModal="showRegisterModal" @cancel="cancelRegister">
      <RegistrationForm
        @switchMode="switchToLoginMode"
        @switchToVerify="switchToVerify"
      />
    </Modal>
    <Modal :showModal="showRegisterModalEmail" @cancel="cancelRegistesr">
      <RegistrationFormWithEmail
      :emailForm="userEmail"
        @switchMode="switchToLoginEmail"
        @switchToVerify="switchToVerifyss"
      />
    </Modal>
    <Modal :showModal="showVerifyModal" @cancel="cancelVerify">
      <VerifyUser />
    </Modal>
    <Modal :showModal="showSendEmailModal" @cancel="cancelSendEmail">
      <SendEmailForRestorePassword @cancel="cancelSendEmail" />
    </Modal>
    <Modal
      :showModal="showRestorePasswordModal"
      @cancel="cancelRestorePassword"
    >
      <RestorePasswordForm @cancel="cancelRestorePassword" />
    </Modal>
    <NewDisng  @openModal="showLogin"  @switchMode="switchToLoginModeFor" @switchModeValue="switchToLoginModeForTry"/>
  </div>
</template>

<script>
import "src/scss/build.scss";
import { headerScroll } from "src/js/modules/headerScroll";
// import { getCodeCountries } from "src/js/modules/getCodeCountries";
import { loadAnimation } from "src/js/modules/animations/loadAnimation";
// Components
import HeaderHomePage from "@/components/HeaderHomePage.vue";
import ConsultationForm from "@/components/shared/forms/ConsultationForm.vue";
import ContactForm from "@/components/shared/forms/ContactForm.vue";
import FooterHomePage from "@/components/FooterHomePage.vue";
import DotsList from "@/components/shared/UI/DotsList.vue";
import NewDisng from "@/components/NewDesign.vue"
// -----
import Modal from "@/components/Modal.vue";
// import Forms
import LoginForm from "@/components/shared/forms/LoginForm.vue";
import RegistrationForm from "@/components/shared/forms/RegistrationForm.vue";
import RegistrationFormWithEmail from "@/components/shared/forms/RegistrationFormWithEmail.vue";
import VerifyUser from "@/components/shared/forms/VerifyUser.vue";
import SendEmailForRestorePassword from "../components/shared/forms/SendEmailForRestorePassword.vue";
import RestorePasswordForm from "../components/shared/forms/RestorePasswordForm.vue";
// -----------------
import { ScrollAnimation } from "../js/modules/animations/scroll-animation";
export default {
  name: "HomePage",
  data() {
    return {
      showRegisterModal: false,
      showRegisterModalEmail: false,
      showLoginModal: false,
      showVerifyModal: false,
      showSendEmailModal: false,
      showRestorePasswordModal: false,
      userEmail: "",
      userEmailValue: ""
    };
  },
  props: {},
  components: {
    HeaderHomePage,
    DotsList,
    ConsultationForm,
    ContactForm,
    FooterHomePage,
    Modal,
    LoginForm,
    RegistrationForm,
    VerifyUser,
    RegistrationFormWithEmail,
    NewDisng,
    SendEmailForRestorePassword,
    RestorePasswordForm,
  },
  mounted() {
    const { key, email } = this.$route.query;

    if (key && email) {
      this.showRestorePassword();
    }

    // headerScroll();
    // getCodeCountries();
    loadAnimation();
    ScrollAnimation();
  },
  beforeRouteEnter(to, from, next) {
  const isLogged =  localStorage.getItem("token") && localStorage.getItem("refreshToken")
  if (isLogged) {
    next("/user/chatbots");
  } 
  next(); 
},
  methods: {
    forgetPassword() {
      this.showSendEmail();
      this.cancelLogin();
    },
    showLogin() {
      this.showLoginModal = true;

    },
    switchToRegistrationMode() {
      this.showLoginModal = false;
      this.showRegisterModalEmail = false;
      this.showRegisterModal = true;
    },
    switchToLoginMode() {
      this.showRegisterModal = false;
      this.showLoginModal = true;
    },
    switchToLoginEmail() {
      this.showRegisterModalEmail = false;
      this.showRegisterModal = false;
      this.showLoginModal = true;
    },
    showSendEmail() {
      this.showSendEmailModal = true;
    },
    switchToLoginModeFor() {
      this.showRegisterModal = true;
      this.showLoginModal = false;
      this.showRegisterModalEmail = false;
    },
    switchToLoginModeForTry(email) {
      this.showRegisterModalEmail = true;
      this.showLoginModal = false;
      this.userEmail = email
      console.log(email);
    },


    showRestorePassword() {
      this.showRestorePasswordModal = true;
    },
    cancelLogin() {
      this.showLoginModal = false;
    },
    cancelRegister() {
      this.showRegisterModal = false;
    },
    cancelRegistesr() {
      this.showRegisterModalEmail = false;
    },
    cancelVerify() {
      this.showVerifyModal = false;
    },
    cancelSendEmail() {
      this.showSendEmailModal = false;
    },
    cancelRestorePassword() {
      this.showRestorePasswordModal = false;
    },
    switchToVerify() {
      this.showVerifyModal = true;
      this.showRegisterModal = false;
    },
    switchToVerifyss() {
      this.showVerifyModal = true;
      this.showRegisterModalEmail = false;
      this.showRegisterModal = false;
    },
  },
};
</script>

<style scoped lang="scss">
.right {
  justify-content: flex-end !important;
}
</style>
